export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/tiktok-icon.9a987236.svg","height":20,"width":16,"blurWidth":0,"blurHeight":0};